import { SearchUser } from '../../../modules/user-role/contract/search-user.contract';

export interface EmailRecipient {
  userId: string;
  name: string;
  email?: string;
}

export function searchUserToEmailRecipient(user: SearchUser): EmailRecipient {
  const fullName = [user.firstName, user.name].filter(Boolean).join(' ');
  return { userId: user.userId, name: fullName };
}
